import { useState } from 'react';
import { Category } from '@/types';

export function useSearchLogic(categories: Category[]) {
  const [searchAccount, setSearchAccount] = useState('');
  const [searchTeam, setSearchTeam] = useState('');
  const [searchProject, setSearchProject] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [searchResults, setSearchResults] = useState<{ category: Category; rulePath: string[] }[]>([]);

  const isInRange = (value: string, rangeStart: string, rangeEnd: string): boolean => {
    // Remove any leading/trailing whitespace
    const cleanValue = value.trim();
    const cleanStart = rangeStart.trim();
    const cleanEnd = rangeEnd.trim();

    // If any of the values are empty, return false
    if (!cleanValue || !cleanStart || !cleanEnd) return false;

    // Compare the strings
    return cleanValue >= cleanStart && cleanValue <= cleanEnd;
  };

  const findMatchingCategories = () => {
    const results: { category: Category; rulePath: string[] }[] = [];
    
    const searchInCategory = (category: Category, path: string[] = []) => {
      const currentPath = [...path, category.name];
      
      category.mappingRules?.forEach(rule => {
        const accountMatch = !searchAccount || 
          (rule.mainAccountFrom && rule.mainAccountTo && 
           isInRange(searchAccount, rule.mainAccountFrom, rule.mainAccountTo));
           
        const teamMatch = !searchTeam || 
          (rule.teamFrom && rule.teamTo && 
           isInRange(searchTeam, rule.teamFrom, rule.teamTo));
          
        const projectMatch = !searchProject || 
          (rule.projectFrom && rule.projectTo && 
           isInRange(searchProject, rule.projectFrom, rule.projectTo));

        if (accountMatch && teamMatch && projectMatch) {
          results.push({
            category,
            rulePath: currentPath
          });
        }
      });

      category.children.forEach(child => {
        searchInCategory(child, currentPath);
      });
    };

    categories.forEach(category => searchInCategory(category));
    return results;
  };

  const handleSearch = () => {
    if (!searchAccount && !searchTeam && !searchProject) {
      return;
    }
    
    console.log('Searching with criteria:', { searchAccount, searchTeam, searchProject });
    const results = findMatchingCategories();
    console.log('Search results:', results);
    
    setSearchResults(results);
    setIsOpen(true);
  };

  return {
    searchAccount,
    setSearchAccount,
    searchTeam,
    setSearchTeam,
    searchProject,
    setSearchProject,
    isOpen,
    setIsOpen,
    searchResults,
    handleSearch,
  };
}